// src/lib/vision/vision.js
import {
  FaceLandmarker,
  ImageSegmenter,
  FilesetResolver,
} from "@mediapipe/tasks-vision";

let faceLandmarker = null;
let segmenter = null;

/**
 * Carga los binarios WASM y modelos. Solo se ejecuta 1 vez.
 * Usa @latest/wasm (recomendado en la guía Web) y modelos "Latest".
 * Modelos:
 *  - Face Landmarker (float16)
 *  - Image Segmenter: Selfie (square, 2 clases). Si falla, fallback a Multiclass.
 */
export async function initVision() {
  if (faceLandmarker && segmenter) return;

  // WASM recomendado para Web/JS
  const fileset = await FilesetResolver.forVisionTasks(
    "https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm"
  ); // :contentReference[oaicite:1]{index=1}

  // ---------- Face Landmarker ----------
  // Modelo "Latest" (bundle .task, float16)
  const FACE_LANDMARKER_MODEL =
    "https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/latest/face_landmarker.task"; // :contentReference[oaicite:2]{index=2}

  faceLandmarker = await FaceLandmarker.createFromOptions(fileset, {
    baseOptions: {
      modelAssetPath: FACE_LANDMARKER_MODEL,
    },
    runningMode: "IMAGE",
    numFaces: 1,
    outputFaceBlendshapes: true,
    outputFacialTransformationMatrixes: false,
  });

  // ---------- Image Segmenter ----------
  // Opción 1 (preferida): Selfie (square) 256x256, float16 (2 clases: fondo/persona)
  const SELFIE_SEGMENTER_SQUARE =
    "https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_segmenter/float16/latest/selfie_segmenter.tflite"; // :contentReference[oaicite:3]{index=3}

  // Fallback: Multiclass 256x256, float32 (6 clases: background, hair, body-skin, face-skin, clothes, accessories)
  const SELFIE_MULTICLASS_256 =
    "https://storage.googleapis.com/mediapipe-models/image_segmenter/selfie_multiclass_256x256/float32/latest/selfie_multiclass_256x256.tflite"; // :contentReference[oaicite:4]{index=4}

  // Intento primario: Selfie (square)
  try {
    segmenter = await ImageSegmenter.createFromOptions(fileset, {
      baseOptions: {
        modelAssetPath: SELFIE_SEGMENTER_SQUARE,
      },
      runningMode: "IMAGE",
      outputCategoryMask: true, // máscara uint8 por categoría (ganadora)
      outputConfidenceMasks: false, // puedes poner true si necesitas mapas de confianza
    });
  } catch (err) {
    console.warn(
      "[vision] SelfieSegmenter (square) falló, usando Multiclass:",
      err
    );
    // Fallback: Multiclass
    segmenter = await ImageSegmenter.createFromOptions(fileset, {
      baseOptions: {
        modelAssetPath: SELFIE_MULTICLASS_256,
      },
      runningMode: "IMAGE",
      outputCategoryMask: true,
      outputConfidenceMasks: false,
    });
  }
}

export function getFaceLandmarker() {
  if (!faceLandmarker)
    throw new Error(
      "FaceLandmarker no inicializado: llama initVision() primero."
    );
  return faceLandmarker;
}

export function getSegmenter() {
  if (!segmenter)
    throw new Error(
      "ImageSegmenter no inicializado: llama initVision() primero."
    );
  return segmenter;
}
